export default __webpack_public_path__ + "static/media/loading-skull-noun.d7293d44.gif";